// ABOUTME: The feeling scene's stage geometry and where 2A's copy block sits against it.
// ABOUTME: Shared by FeelingScene (which draws the stage) and Screen2A (which places the copy above the scene's name).

import { HEADER_HEIGHT_PX } from '../../crossing/horizon';

// The prototype's stage: 470 plate plus the 190px of sea it shows each side, 100px shorter than the plate. The horizon is
// at 60% of its height and the face sits on it.
export const STAGE_WIDTH = 850;
export const STAGE_HEIGHT = 370;
export const STAGE_HORIZON = 0.6 * STAGE_HEIGHT;
export const FEELING_PLATE_WIDTH = 470;
export const FACE_SIZE = 66;
export const FACE_ICON_SIZE = 54;
// The ring's centre stays where the bare 54px face's centre was (165.2 + 27).
export const FACE_TOP = 165.2 - (FACE_SIZE - FACE_ICON_SIZE) / 2;
export const NAME_HEIGHT = 44;

// How far the name's top sits above the horizon line, in stage px.
export const FEELING_NAME_ABOVE_LINE = STAGE_HORIZON - (FACE_TOP - NAME_HEIGHT);

const COPY_GAP_ABOVE_NAME_PX = 4;
const COPY_GAP_BELOW_HEADER_PX = 8;

interface FeelingCopyRoom {
  line: number;
  frameSc: number;
  frameH: number;
}

// The copy block's fixed box, as top and bottom offsets from the viewport edges: from just under the header to just above the name.
export function feelingCopyBox({ line, frameSc, frameH }: FeelingCopyRoom): { top: number; bottom: number } {
  const nameTop = line - FEELING_NAME_ABOVE_LINE * frameSc;
  return { top: HEADER_HEIGHT_PX + COPY_GAP_BELOW_HEADER_PX, bottom: frameH - (nameTop - COPY_GAP_ABOVE_NAME_PX) };
}
